export enum SurfaceState {
  Default = 'default',
  Highlighted = 'highlighted',
  Selected = 'selected',
  Disabled = 'disabled',
}
